import {
    GET_REASON_CODE,
    GET_REQUISITION_REASON_CODE,
    SET_REASON_CODE,
    SET_REQUISITION_REASON_CODE
} from "./ReasonCodeType"

const getReasonCode = () => ({
    type: GET_REASON_CODE
});

const setReasonCode = (codeList: any) => ({
    type: SET_REASON_CODE,
    codeList
});

const getRequisitionReasonCode = () => ({
    type: GET_REQUISITION_REASON_CODE
});

const setRequisitionReasonCode = (codeList: any) => ({
    type: SET_REQUISITION_REASON_CODE,
    codeList
});

export {
    getReasonCode,
    setReasonCode,
    getRequisitionReasonCode,
    setRequisitionReasonCode
}
